import { render } from "./epicFury.vue?vue&type=template&id=670f162e&scoped=true"
import script from "./epicFury.vue?vue&type=script&lang=js"
export * from "./epicFury.vue?vue&type=script&lang=js"

import "./epicFury.vue?vue&type=style&index=0&id=670f162e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670f162e"]])

export default __exports__